import React, { useState } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
} from "@material-ui/core";
import t from "../common/localization";
import { useEffectAsync } from "../reactHelper";
import EditCollectionView from "../EditCollectionView";
import { formatBoolean, formatPosition } from "../common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { green, blue, red, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    marginLeft: "auto",
    display: "flex",
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 730,
  },
}));

const BladesView = ({
  updateTimestamp,
  onMenuClick,
  handleOnEdit,
  handleOnRemove,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/blades");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setItems(res);
      setSearchList(res);
    }
  }, [updateTimestamp]);

  const searchChange = (val) => {
    const newItems = items.filter((current) => {
      const { name, packageId, newPackageId, contact } = current;
      let checkval = `${name || ""}${packageId || ""}${newPackageId || ""}${
        contact || ""
      }`;
      checkval = checkval.toLowerCase();
      return checkval.includes(val && val.toLowerCase());
    });

    setSearchList(newItems);
  };

  const reset = () => {
    console.log("val");
  };
  const filterItems = searchList.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()
  );

  return (
    <>
      <SearchBar
        // value= {'search'}
        onChange={searchChange}
        onCancelSearch={reset}
        placeholder="Search here..."
        className="searchBarInput"
        style={{
          borderRadius: 15,
          height: 35,
          boxShadow: "2px 2px 2px 2px #dbddef",
          fontSize: 12,
          marginBottom: "10px",
          width: "300px",
        }}
        // onRequestSearch={() => doSomethingWith()}
      />
      <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.tableAction}
          size="small"
          style={{ whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>{t("sharedName")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("sharedPackageId")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("sharedNewPackageId")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("sharedLink")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("accountEmail")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("fcmServerKey")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("fcmServiceKey")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("devicesContact")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("minVersion")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("sharedDisabled")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("currentVersion")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("updateTime")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("updateFeatures")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("updatePush")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("creationTime")}
              </TableCell>
              <TableCell className={classes.tCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {filterItems.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.name}</b>}</TableCell>
                <TableCell>{<b>{item.packageId}</b>}</TableCell>
                <TableCell>{<b>{item.newPackageId}</b>}</TableCell>
                <TableCell>{item.link}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{item.fcmServerKey}</TableCell>
                <TableCell>{item.fcmServiceAccountKey}</TableCell>
                <TableCell>{item.contact}</TableCell>
                <TableCell>{item.minVersion}</TableCell>
                <TableCell>{item.disabled}</TableCell>
                <TableCell>{item.currentVersion}</TableCell>
                <TableCell>{item.updateTime}</TableCell>
                <TableCell>{item.updateFeatures}</TableCell>
                <TableCell>{item.updatePush}</TableCell>
                <TableCell>{item.creationTime}</TableCell>
                <TableCell className={classes.columnAction} padding="none">
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={(event) => handleOnEdit(item.id)}>
                          <EditIcon
                            fontSize="small"
                            style={{ color: blue[600] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                    <Avatar className={classes.small}>
                      {
                        <IconButton
                          onClick={(event) => handleOnRemove(item.id)}
                        >
                          <ClearIcon
                            fontSize="small"
                            style={{ color: grey[450] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const BladesPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={BladesView}
        editPath="/blades"
        endpoint="blades"
        successDialogShow={false}
      />
    </>
  );
};

export default BladesPage;
